import { render, staticRenderFns } from "./inform.vue?vue&type=template&id=772a9eb0&scoped=true"
import script from "./inform.vue?vue&type=script&lang=js"
export * from "./inform.vue?vue&type=script&lang=js"
import style0 from "./inform.vue?vue&type=style&index=0&id=772a9eb0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "772a9eb0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('772a9eb0')) {
      api.createRecord('772a9eb0', component.options)
    } else {
      api.reload('772a9eb0', component.options)
    }
    module.hot.accept("./inform.vue?vue&type=template&id=772a9eb0&scoped=true", function () {
      api.rerender('772a9eb0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/template/frontPageManage/configureManage/mobilePreview/components/inform.vue"
export default component.exports